let _button = $('.js-discover-more');
let _el = $('.c-teaser-box__inner');
let _sub = _el.find('> div');

export function init() {
	checkHeight();
	$(window).on('resize', checkHeight);
}

function checkHeight() {
	if (_sub.outerHeight() > _el.outerHeight()) {
		_button.show();
		clickEvent();
	}
}

function clickEvent() {
	_button.off('click');
	_button.on('click', function () {
		var _this = $(this);
		var _parent = _this.parent();
		var text = (_parent.hasClass('is-expanded')) ? _translations.read_more : _translations.close;
		_parent.toggleClass('is-expanded');
		_this.html(text);
	});
}



// WEBPACK FOOTER //
// ./src/js/modules/category-description.js